// A clock that ticks on an interval so ages and the status bar time re-render
// without calling Date.now during render.
import { useEffect, useState } from 'react';

export const NOW_TICK_MS = 30_000;

export function useNow(tickMs: number = NOW_TICK_MS): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), tickMs);
    return () => clearInterval(timer);
  }, [tickMs]);
  return now;
}
